export default {
  login_register: "S'identifier/S'enregistrer",
  booking_confirmation_title: 'Confirmation de réservation',
  booking_confirmation_body: 'Merci pour votre réservation. Vous trouverez vos informations de réservation ci-dessous.',
  insurance_requirements_modal_disclaimer: `En faisant cette réservation, je confirme que: Je n'ai eu aucune condamnation ni infraction pour conduite automobile au cours des 5 dernières années. Je n'ai pas vu une proposition refusée, une police annulée ou un renouvellement refusé, ni été tenu de payer une prime majorée, ni aucune condition particulière imposée par un assureur automobile. Je n'ai pas été disqualifié pour conduire. Je n'ai pas de poursuites ni d'enquête policière en cours. Je n'ai pas été condamné pour des infractions liées au vol, à la fraude ou à la malhonnêteté au cours des 5 dernières années. Je n'ai pas souffert de troubles de la vue ou de l'ouïe (non corrigés par des lunettes ou un appareil auditif), des troubles cardiaques, du diabète, des crises ou toute infirmité physique ou mentale de quelque nature que ce soit. Je n'ai eu aucun accident au cours des 5 dernières années. Veuillez cliquer {0} si vous ne remplissez pas ces conditions`,
  insurance_requirements_here: 'ici',
  insurance_requirements: `J'ai lu et j'accepte de répondre aux {0}`,
  ir: `Exigences D'assurance`,
  location: 'Lieu',
  pickup_location: 'Lieu de livraison',
  dropoff_location: 'Lieu de restitution',
  vehicle: 'Véhicule',
  pickup_and_dropoff: 'Livraison et restitution (heure locale)',
  distance_allowance: 'Distance allouée',
  view_voucher: 'Voir le reçu',
  view_more_bookings: 'Voir plus de réservations',
  identity_verification_body: 'Vous devrez vérifier votre identité avant de pouvoir récupérer le véhicule',
  identity_verification_title: 'Vérifier identité',
  search_again: 'Chercher à nouveau',
  not_available: 'Drive &amp; Go est actuellement uniquement disponible pour les résidents et détenteurs de permis de conduire de {profiles}, mais nous ajoutons régulièrement de nouveaux pays.',
  check_if_included: 'Vérifiez si votre pays est inclus.',
  included_in_booking: 'Votre réservation comprend :',
  cdw_with_excess: 'Franchise de dégâts',
  theft_protection: 'Franchise de vol',
  risk_reduction: 'Réduction de risques',
  free_extras: 'Cette réservation vous donne droit à <br /> deux suppléments gratuits.',
  total_cost: 'Coût total de la location',
  continue: 'Continuer',
  luggage_large_short_label: 'G',
  luggage_medium_short_label: 'M',
  luggage_small_short_label: 'P',
  luggage_large_long_label: 'grand',
  luggage_medium_long_label: 'moyen',
  luggage_small_long_label: 'petit',
  fuel_unspecified_label: 'non spécifié',
  transmission_manual_label: 'Manuel',
  transmission_automatic_label: 'Automatique',
  make_a_booking: 'Réserver',
  pickup_date: 'Date de livraison',
  dropoff_date: 'Date de restitution',
  driver_age: 'Conducteur âgé de 30 à 65 ans',
  enter_driver_age: 'Veuillez entrer l\'âge du conducteur',
  promo_code: 'Code promotionnel',
  search: 'Recherche',
  dropoff_date_cannot_be_before_pickup_date: 'La date de restitution ne peut pas être antérieure à celle de livraison',
  pickup_date_cannot_be_in_the_past: 'L\'heure de livraison ne peut pas être dans le passé',
  pickup_time_cannot_be_in_the_past: 'La date de livraison ne peut pas être dans le passé',
  dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'L\'heure de restitution doit être ultérieure à celle de livraison si elle a lieu le même jour',
  vehicle_filters: 'Filtres de véhicules',
  reset: 'Réinitialiser',
  transmission: 'Boîte de vitesses',
  all: 'Tous',
  manual: 'Manuel',
  auto: 'Automatique',
  passengers: 'Passagers',
  vehicle_type: 'Type de véhicule',
  filter: 'Filtrer',
  vehicle_search: 'Recherche de véhicule',
  edit: 'Modifier',
  no_results: 'Aucun résultat ne correspond à vos filtres.',
  small_cars: 'Petits véhicules',
  medium_cars: 'Véhicules moyens',
  large_cars: 'Grands véhicules',
  estate_cars: 'Voitures familiales',
  suvs: 'Véhicules utilitaires sport',
  mpvs: 'Monospaces',
  vans: 'Camionnettes',
  camper_vans: 'Camping-cars',
  premium: 'Véhicules de luxe',
  unspecified: 'non spécifié',
  large: 'grand',
  medium: 'moyen',
  small: 'petit',
  automatic: 'automatique',
  you_have_been_refunded: 'Vous avez été remboursé.',
  please_customer_service: 'Veuillez contacter notre service client pour effectuer une réservation.',
  contact_customer_service: 'Contacter le service client',
  booking_failed: 'Votre réservation n\'a pas pu être traitée.',
  summary: 'Résumé',
  reforestation_and_protection: 'Soutenez la reforestation et la protection de la forêt tropicale au Costa Rica',
  cost_of_rental: 'Coût de location',
  to_pay_now: 'Payer maintenant',
  greenheart_donation: 'Don Green Heart',
  tc_agreement: 'J\'ai lu et j\'accepte les {0}.',
  tc: 'Conditions d\'utilisation',
  receive_offers: 'Je veux recevoir des offres par e-mail.',
  donate: 'Oui, je veux faire un don de {amount}',
  pay_now: 'Payer {amount} maintenant',
  driver_details: 'Renseignements du conducteur',
  complete_driver_details: 'Veuillez remplir les renseignements du conducteur',
  are_you_the_driver: 'Êtes-vous le conducteur ?',
  have_an_account: 'Possédez-vous déjà un compte ?',
  login: 'S\'identifier',
  or: 'ou',
  first_name: 'Prénom du conducteur',
  last_name: 'Nom de famille du conducteur',
  email: 'Adresse e-mail',
  phone_number: 'Numéro de téléphone portable',
  unable_to_save_driver_information: 'Impossible de sauvegarder les données du conducteur. Veuillez réessayer',
  pay_on_arrival: 'Payer à l\'arrivée',
  pay_online_now: 'Payer en ligne maintenant',
  day: 'Jour',
  choose_location: 'Choisissez un lieu',
  location_not_found: 'Désolé, nous n\'avons pas pu trouver le lieu demandé.',
  add: 'Ajouter',
  remove: 'Retirer',
  free_extra: 'Bonus gratuit',
  free: 'GRATUIT !',
  fast_track_notice: 'Des restrictions d\'origine de papiers s\'appliquent à se service. Il est uniquement disponibles pour les détenteurs de papiers de',
  complete_booking: 'Conclure la réservation',
  choose_card: 'Veuillez choisir une carte ou bien en ajouter une.',
  add_billing_details: 'Veuillez ajouter les renseignements de facturation.',
  card_number: 'Numéro de carte',
  card_holder_name: 'Nom du détenteur de la carte',
  card_exp: 'MM / AA',
  card_cvc: 'CVC',
  save_card: 'Sauvegarder carte ?',
  amount_charged: 'Votre carte sera débitée',
  payment_confirmation: 'Confirmer la réservation et payer',
  payment_methods: 'méthodes de paiement disponibles',
  use_saved_card: 'x utiliser la carte sauvegardée',
  use_different_card: '+ utiliser une carte différente',
  book_now: 'Réservez maintenant',
  minimum_age: 'Plus de {age} ans uniquement',
  excess_liability: 'Assurance responsabilité',
  security_deposit: 'Dépôt de garantie',
  fuel_policy: 'Politique de carburant',
  like_for_like: 'Réservoir similaire',
  full_to_full: 'Réservoir plein',
  miles_per_rental: '{mileage} miles gratuits par location',
  km_per_rental: '{mileage} kms gratuits par location',
  unlimited: 'Illimité',
  unlimited_mileage: 'Millage illimité',
  unlimited_mileage_km: 'Kilométrage illimité',
  non_amendable: 'Non modifiable',
  non_refundable: 'Non remboursable',
  free_cancellation_until: 'Annulation gratuite jusqu\'au',
  cancellation_in_line_with: 'Annulation sujette aux',
  tcs: 'Conditions d\'utilisation',
  free_extras_on_collection: 'Deux suppléments gratuits à la récupération',
  glass_and_tyres_covered: 'Vitres et pneus couverts',
  number_of_passengers: 'Nombre de passagers',
  number_of_bags: 'Nombre de bagages',
  fuel_type: 'Type de carburant',
  co2: 'CO2',
  aircon: 'Climatisation',
  refrigeration: 'Réfrigéré',
  book_type: 'Réserver {type}',
  processing: 'Traitement en cours',
  actual_price: 'Prix actuel',
  tooltip: 'Le prix en ${currencyCode} est une estimation basée sur le taux de change, le prix en ${currency} est contractuel',
  deposit: 'Acompte',
  pay_online: 'Payer en ligne maintenant',
  pay_online_without_extras: 'Prix de location',
  extras_on_arrival: 'Suppléments à l\'arrivée',
  insurance_on_arrival: 'Réduction de risques - Payer à l\'arrivée',
  insurance_online: 'Réduction de risques - Payer maintenant',
  extras_online: 'Payer suppléments maintenant',
  green_heart_donation: 'Don Green Heart',
  aircon_lower: 'climatisation',
  why_use_drive_and_go: 'Pourquoi utiliser Drive & Go ?',
  straight_to_car: 'Accès direct au véhicule',
  no_queues: 'Pas de file d\'attente',
  self_checkout: 'Récupération libre',
  cant_lose_key: 'Impossible de perdre sa clé',
  online_id_check: 'Vérification d\'identité en ligne',
  phone_as_key: 'Le téléphone est votre clé',
  premiumplus_benefits_includes: 'Avantages Premium Plus+ également inclus',
  book_drive_go: 'Réserver en Drive & Go',
  duration: 'Durée',
  to_pay_on_arrival: 'Payer à l\'arrivée',
  return_date: 'Date de retour',
  postcode: 'Le numéro postal',
  country: 'Pays',
  my_profile: 'Mon profil',
  drive_and_go: {
    drive_and_go: 'Drive And Go',
    available_countries: 'Drive &amp; Go est actuellement uniquement disponible pour les résidents et détenteurs de permis de conduire des pays suivants :',
    drive_and_go_today: 'Réservez en Drive & Go aujourd\'hui !',
    drive_and_go_shortened: 'Drive & Go',
    why_use_drive_and_go: 'Pourquoi utiliser Drive & Go ?',
    straight_to_car: 'Accès direct au véhicule',
    no_queues: 'Pas de file d\'attente',
    self_checkout: 'Récupération libre',
    cannot_lose_the_key: 'Impossible de perdre sa clé',
    online_id_check: 'Vérification d\'identité en ligne',
    phone_as_a_key: 'Le téléphone est votre clé',
    premium_plus_benefits_also_included: 'Avantages Premium Plus+ également inclus',
    book_drive_and_go: 'Réserver en Drive & Go'
  },
  my_bookings: 'Mes réservations',
  no_bookings: 'Aucune réservation',
  no_bookings_to_display: 'Aucune réservation à afficher.',
  search_great_car_rental_deals: 'Search great car rental deals for your next trip.',
  odometer_at_collection: 'Odomètre à la restitution',
  fuel_at_collection: 'Carburant à la restitution',
  start_check_in: 'Démarrer l\'enregistrement',
  start_collection: 'Démarrer la récupération',
  recent_bookings: 'Réservations récentes',
  additional_options: 'Options supplémentaires',
  booking_details: 'Détails de la réservation',
  price_for_x_days: 'Prix pour {qty_of_days} jour | Prix pour {qty_of_days} jours',
  cancelled: 'Annulée',
  upcoming: 'À venir',
  active: 'Active',
  damage: {
    updated_damage_report_submitted: 'Un rapport de dégâts mis à jour a été envoyé. Un membre de notre équipe du service client vous contactera si besoin est.',
    add_additional_damage: 'Ajouter dégâts supplémentaires',
    you_may_report_additional_damage_up_to: 'Vous pouvez signaler des dégâts supplémentaires jusqu\'à 24 heures après restitution du véhicule',
    specify_damage: 'Spécifier les dégâts',
    please_choose_the_area_and_type_of_damage: 'Veuillez choisir la zone et le type de dégâts',
    type_of_damage: 'Type de dégâts',
    is_this_more_than_5_cm: 'Font-ils plus de 5 cms ?',
    please_take_or_select_a_photo: 'Veuillez prendre ou bien sélectionner une photo',
    please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Assurez-vous que les dégâts soient bien visibles sur l\'image',
    if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' Si vous souhaitez ajouter une autre photo, appuyez sur l\'icône pour en ajouter une',
    save_image: 'Sauvegarder l\'image',
    save_images: 'Sauvegarder les images',
    damage_saved_successfully: 'Dégâts sauvegardés',
    add_photo: 'Ajouter une photo'
  },
  checkout: {
    start_collection: 'Démarrer la récupération',
    collect_vehicle: 'Récupérer le véhicule',
    we_will_let_you_know_the_details: 'Nous vous donnerons le lieu et tous les détails nécessaires pour vous permettre de localiser le véhicule de location.',
    inspect: 'Inspecter',
    we_will_ask_for_four_photos_from_each_corner: 'Nous allons vous demander quatre photos de chaque coin du véhicule, ainsi que de tout dégât n\'étant pas déjà enregistré.',
    fuel_and_milage: 'Carburant et kilométrage',
    you_confirm_the_readings_at_the_start_of_your_hire: 'Vous pouvez confirmer le compteur kilométrique et la quantité de carburant au début de votre location.',
    sign: 'Signer',
    sign_the_rental_agreement: 'Signer l\'accord de location.',
    away_you_go: 'Et c\'est parti !',
    you_are_free_to_take_to_the_road: 'Vous pouvez prendre la route !',
    collect_your_vehicle: 'Récupérer votre véhicule',
    get_directions: 'Obtenir un itinéraire',
    hide_directions: 'Cacher l\'itinéraire',
    local_time: 'heure locale',
    tel: 'Tel',
    getting_to_the_location: 'Se rendre à la location',
    get_vehicle_details: 'Obtenir les détails du véhicule',
    view_map: 'Voir carte',
    unlock_vehicle_and_continue: 'Débloquer le véhicule et continuer',
    unable_to_connect_to_vehicle: 'Impossible de se connecter au véhicule',
    we_were_unable_to_connect_to_the_vehicle_please_check: 'Nous n\'avons pas pu nous connecter au véhicule. Veuillez vous assurer d\'être près du bon véhicule et réessayer.',
    we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'Nous n\'avons pas pu trouver votre location. Veuillez réessayer plus tard.',
    odometer_and_fuel: 'Odomètre et carburant',
    odometer: 'Compteur kilométrique',
    please_confirm_the_odometer_and_fuel_readings: 'Si possible, veuillez confirmer les relevés du compteur kilométrique et du carburant',
    the_odometer_field_is_required: 'Le champ du compteur kilométrique est requis',
    and_must_be_greater_than_the_checkout_odometer: 'et il doit être supérieur au compteur de fin de location',
    confirm: 'Confirmer',
    please_take_a_photo_from_each_corner_of_the_vehicle: 'Veuillez prendre une photo de chaque coin du véhicule',
    pre_existing_damage: 'Dégâts préexistants',
    no_pre_existing_damage: 'Aucun dégât préexistant.',
    new_damage: 'Nouveau dégât',
    add_additional_damage: 'ajouter un nouveau dégât',
    no_new_damage_to_report: 'Aucun nouveau dégât à signaler',
    checkout_complete: 'Vérifications terminées',
    start_rental: 'Démarrer la location',
    congratulations_name_it_is_time_to_take_to_the_road: 'Félicitations, {customer_name} ! C\'est l\'heure de prendre la route !',
    we_are_unable_to_complete_your_vehicle_checkout: 'Nous n\'avons pas pu achever les vérifications du véhicule.',
    please_do_the_following: 'Veuillez exécuter les étapes suivantes',
    remove_all_belonging_and_lock_the_vehicle: 'Retirer toutes vos affaires et fermer le véhicule.',
    lock_vehicle: 'Fermer le véhicule',
    once_you_have_contacted_customer_services: 'Une fois que vous avez contacté le service client',
    vehicle_location: 'Location de véhicule',
    collect_your: 'Récupérer votre',
    from: 'De',
    key_in_glove_box: 'avaimesi sijaitsee hansikaslokerossa',

    keyholder: {
      not_detected: 'Clé non détectée dans le porte-clés',
      not_detected_please_try_again: 'Veuillez placer votre clé dans le porte-clés, puis réessayez.',

      not_installed: 'Porte-clés non installé',
      not_installed_please_contact_customer_service: `Le porte-clés n'est pas installé, veuillez contacter le service client.`,
    },
    keyring: {
      look_up_failed: 'Échec de la recherche du trousseau de clés',
      look_up_failed_please_contact_customer_service: 'Porte-clés chercher faled, veuillez contacter le service client.',
    },
    key: {
      invalid: `La clé n'est pas valide`,
      invalid_please_contact_customer_service: `Votre clé n'est pas valide, veuillez contacter le service client.`,

      expired: 'La clé a expiré',
      expired__please_contact_customer_service: 'Votre clé a expiré, veuillez contacter le service client.',
    }
  },
  checkin: {
    start_check_in: 'Démarrer l\'enregistrement',
    vehicle_location: 'Location de véhicule',
    tell_us_where_you_have_parked: 'Dites-nous où vous avez garé le véhicule.',
    fuel_and_milage: 'Carburant et kilométrage',
    you_confirm_the_readings_at_the_end_of_your_hire: 'Vous pouvez confirmer le compteur kilométrique et la quantité de carburant à la fin de votre location.',
    inspect: 'Inspecter',
    we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage: 'Nous allons vous demander quatre photos de chaque coin du véhicule, ainsi que de tout dégât survenu lors de la location.',
    lock: 'Fermer',
    check_you_have_left_no_belonging_then_lock_the_vehicle: 'Vérifiez bien que vous n\'avez rien laissé dans le véhicule avant de le fermer.',
    please_tell_us_where_you_have_parked_the_vehicle: 'Dites-nous où vous avez garé le véhicule.',
    once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Une fois le véhicule fermé, vous ne pourrez plus l\'ouvrir.',
    name_please_check_you_have_left_no_belongings_then_lock_the_vehicle: '{first_name}, veuillez vérifier que vous n\'avez rien laissé, verrouillez le véhicule et, si nécessaire, remettez la clé physique au détenteur de la clé.',
    lock_vehicle: 'Fermer le véhicule',
    complete_check_in: 'Achever la restitution',
    inspection: 'Inspection',
    complete_vehicle_check_in: 'Achever la restitution du véhicule',
    we_are_unable_to_complete_your_vehicle_check_in: 'Nous n\'avons pas pu achever la restitution de votre véhicule.',
    please_contact_customer_services: 'Veuillez contacter le service client',
    once_you_have_contacted_customer_services: 'Une fois que vous avez contacté le service client',
    please_amend_odometer_to_be_greater_than: 'Veuillez modifier l\'odomètre pour qu\'il soit supérieur à {odometer_value}',
  },
  rental_agreement: {
    rental_agreement: 'Accord de location',
    agreement_between: 'Accord entre',
    and: 'et',
    sign_rental_agreement: 'Signer l\'accord de location',
    i_have_read_and_understood_the_terms_and_conditions: 'J\'ai lu et compris le termes et conditions et j\'accepte l\'état du véhicule'
  },
  full_insurance_no_deposit: 'Assurance complète et aucun dépôt requis',
  excess: '{amount} excédentaire',
  deposit: 'Dépôt de {amount}',
  included_daily_distance: '{distance} {unit} par jour',
  miles: 'miles',
  kilometers: 'kilomètres',
  collection_details_title: 'Détails de la collection',
  collection_details_not_found: 'Aucun détail de collection défini pour cet emplacement',
  free_cancellation: 'Annulation gratuite',
  no_deposit: 'Pas de dépôt',
  benefit_from: 'Profitez de',
  for_only_per_day: 'Pour seulement {price} par jour',
  upgrade_mee: 'UpgradeMee'
}
